import React from 'react';
import styled from 'styled-components';
import {
  IFunnelStepBriefInfoFieldsFragment,
  IUserAliasReplacementFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { getAliasedName } from '../../../../utils/redux/applyAliasReplacements';
import { parseAliasReplacements } from '../../../../utils/redux/util';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import BuilderInfoLabelList from '../../components/BuilderInfoLabelList';

interface IProps {
  convertedOnStep: number;
  steps: IFunnelStepBriefInfoFieldsFragment[];
  aliasReplacements: IUserAliasReplacementFieldsFragment[];
}

const Container = styled(BuilderInfoUI.InfoLabel)`
  white-space: pre;
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 4px;
`;

const MetricValue = styled(BuilderInfoLabelList)`
  margin-left: 4px;
`;

const ConversionContent = ({
  convertedOnStep,
  steps,
  aliasReplacements,
}: IProps) => {
  const parsedAliasReplacements = parseAliasReplacements(aliasReplacements);
  const selectedStepName = getAliasedName(
    steps[convertedOnStep].name,
    steps[convertedOnStep].userAlias?.aliasId ?? null,
    parsedAliasReplacements,
  ).name;

  return (
    <Container>
      conversion rate on
      <MetricValue items={[selectedStepName]} />
    </Container>
  );
};

export default ConversionContent;
